/* eg-oregano-different — arrows and dots for the reason rail.
   Native scroll-snap does the swiping; the arrows step one card, the dots jump
   to a card, and the active dot follows the scroll position. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.egdfInit === 'true') return;
    root.dataset.egdfInit = 'true';

    var rail = root.querySelector('[data-egdf-rail]');
    var cards = root.querySelectorAll('[data-egdf-card]');
    var prev = root.querySelector('[data-egdf-prev]');
    var next = root.querySelector('[data-egdf-next]');
    var dots = root.querySelectorAll('[data-egdf-dot]');
    if (!rail || !cards.length) return;

    function step() {
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function current() {
      var max = rail.scrollWidth - rail.clientWidth;
      // at the far end the last cards can't snap to the start, so count it as the last one
      if (rail.scrollLeft >= max - 1) return cards.length - 1;
      return Math.round(rail.scrollLeft / step());
    }

    function goTo(index) {
      var i = Math.max(0, Math.min(cards.length - 1, index));
      rail.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft });
    }

    var ticking = false;
    function sync() {
      ticking = false;
      var i = current();
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max - 1;
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-active', on);
        dots[d].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
    for (var k = 0; k < dots.length; k++) {
      dots[k].addEventListener('click', function () {
        goTo(Number(this.getAttribute('data-egdf-dot')));
      });
    }

    rail.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    sync();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-egdf]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
